export default {
  Age: {
    name: 'Age',
    lucidKey: 'AGE',
    button_text: 'Age',
    type: 'slider',
    step: 1,
    init: { min: 18, max: 75 },
    default: { min: 18, max: 75 },
    range: { min: 13, max: 85 },
    options: [
      { title: '12 - 17', precodes: ['12', '13', '14', '15', '16', '17'] },
      { title: '18 - 24', precodes: ['18', '19', '20', '21', '22', '23', '24'] },
      { title: '25 - 34', precodes: ['25', '26', '27', '28', '29', '30', '31', '32', '33', '34'] },
      { title: '35 - 44', precodes: ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44'] },
      { title: '45 - 54', precodes: ['45', '46', '47', '48', '49', '50', '51', '52', '53', '54'] },
      { title: '55 - 64', precodes: ['55', '56', '57', '58', '59', '60', '61', '62', '63', '64'] },
      { title: '65+', precodes: ['65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86'] }
    ]
  },
  Education: {
    name: 'Education',
    description: 'What is the highest level of education you have completed?',
    lucidKey: 'STANDARD_EDUCATION',
    button_text: 'Education',
    type: 'checkbox',
    options: [
      { title: 'No Degree', precodes: ['1', '2', '3', '12'] },
      { title: 'High School', precodes: ['4', '5', '6'] },
      { title: 'Associates', precodes: ['7'] },
      { title: 'Bachelors', precodes: ['8', '9'] },
      { title: 'Graduate', precodes: ['10', '11'] }
    ]
  },
  Employment: {
    name: 'Employment',
    description: 'What is your current employment status?',
    lucidKey: 'STANDARD_EMPLOYMENT',
    button_text: 'Employment',
    type: 'checkbox',
    options: [
      { title: 'Full Time', precodes: ['1', '3'] },
      { title: 'Part Time', precodes: ['2', '4'] },
      { title: 'Student', precodes: ['10'] },
      { title: 'Unemployed', precodes: ['7'] },
      { title: 'Retired', precodes: ['6', '9'] },
      { title: 'Other', precodes: ['5', '8', '11', '12'] }
    ]
  },
  Gender: {
    name: 'Gender',
    lucidKey: 'GENDER',
    button_text: 'Gender',
    type: 'checkbox',
    options: [
      { title: 'Male', precodes: ['1'] },
      { title: 'Female', precodes: ['2'] }
    ]
  },
  'Household Income': {
    name: 'Household Income',
    lucidKey: 'STANDARD_HHI_US',
    button_text: 'HHI',
    type: 'slider',
    step: 5000,
    init: { min: 0, max: 255000 },
    range: { min: 0, max: 255000 },
    options: [
      { title: 'Less than $5,000', precodes: ['1'] },
      { title: '$5,000 to $9,999', precodes: ['2'] },
      { title: '$10,000 to $14,999', precodes: ['3'] },
      { title: '$15,000 to $19,999', precodes: ['4'] },
      { title: '$20,000 to $24,999', precodes: ['5'] },
      { title: '$25,000 to $29,999', precodes: ['6'] },
      { title: '$30,000 to $34,999', precodes: ['7'] },
      { title: '$35,000 to $39,999', precodes: ['8'] },
      { title: '$40,000 to $44,999', precodes: ['9'] },
      { title: '$45,000 to $49,999', precodes: ['10'] },
      { title: '$50,000 to $54,999', precodes: ['11'] },
      { title: '$55,000 to $59,999', precodes: ['12'] },
      { title: '$60,000 to $64,999', precodes: ['13'] },
      { title: '$65,000 to $69,999', precodes: ['14'] },
      { title: '$70,000 to $74,999', precodes: ['15'] },
      { title: '$75,000 to $79,999', precodes: ['16'] },
      { title: '$80,000 to $84,999', precodes: ['17'] },
      { title: '$85,000 to $89,999', precodes: ['18'] },
      { title: '$90,000 to $94,999', precodes: ['19'] },
      { title: '$95,000 to $99,999', precodes: ['20'] },
      { title: '$100,000 to $124,999', precodes: ['21'] },
      { title: '$125,000 to $149,999', precodes: ['22'] },
      { title: '$150,000 to $174,999', precodes: ['23'] },
      { title: '$175,000 to $199,999', precodes: ['24'] },
      { title: '$200,000 to $249,999', precodes: ['25'] },
      { title: '$250,000 and above', precodes: ['26'] }
    ]
  },
  Industry: {
    name: 'Industry',
    description: 'Which of the following best describes the industry that you, personally, work in?',
    lucidKey: 'STANDARD_INDUSTRY_PERSONAL',
    button_text: 'Industry',
    type: 'checklist',
    options: [
      { title: 'Accounting', precodes: ['1'] },
      { title: 'Advertising', precodes: ['2'] },
      { title: 'Agriculture/Fishing', precodes: ['3'] },
      { title: 'Architecture', precodes: ['4'] },
      { title: 'Automotive', precodes: ['5'] },
      { title: 'Aviation', precodes: ['6'] },
      { title: 'Banking/Financial', precodes: ['7'] },
      { title: 'Bio-Tech', precodes: ['8'] },
      { title: 'Brokerage', precodes: ['9'] },
      { title: 'Carpenting/Electrical installations/VVS', precodes: ['10'] },
      { title: 'Chemicals/Plastics/Rubber', precodes: ['11'] },
      { title: 'Communications/Information', precodes: ['12'] },
      { title: 'Computer Hardware/Software', precodes: ['13', '14', '15'] },
      { title: 'Construction', precodes: ['16'] },
      { title: 'Consulting', precodes: ['17'] },
      { title: 'Consumer Electronics', precodes: ['18'] },
      { title: 'Consumer Packaged Goods', precodes: ['19'] },
      { title: 'Education', precodes: ['20'] },
      { title: 'Energy/Utilities/Oil and Gas', precodes: ['21'] },
      { title: 'Engineering', precodes: ['22'] },
      { title: 'Environmental Services', precodes: ['23'] },
      { title: 'Fashion/Apparel', precodes: ['24'] },
      { title: 'Food/Beverage', precodes: ['25'] },
      { title: 'Government/Public Sector', precodes: ['26'] },
      { title: 'Healthcare', precodes: ['27'] },
      { title: 'Hospitality/Tourism', precodes: ['28'] },
      { title: 'Human Resources', precodes: ['29'] },
      { title: 'Information Technology/IT', precodes: ['30'] },
      { title: 'Insurance', precodes: ['31'] },
      { title: 'Internet', precodes: ['32'] },
      { title: 'Legal/Law', precodes: ['33'] },
      { title: 'Manufacturing', precodes: ['34'] },
      { title: 'Market Research', precodes: ['35'] },
      { title: 'Marketing', precodes: ['52'] },
      { title: 'Media/Entertainment', precodes: ['37'] },
      { title: 'Military', precodes: ['38'] },
      { title: 'Non Profit/Social services', precodes: ['39'] },
      { title: 'Personal Services', precodes: ['40'] },
      { title: 'Pharmaceuticals', precodes: ['41'] },
      { title: 'Printing Publishing', precodes: ['42'] },
      { title: 'Public Relations', precodes: ['43'] },
      { title: 'Real Estate/Property', precodes: ['44'] },
      { title: 'Retail/Wholesale trade', precodes: ['45'] },
      { title: 'Sales', precodes: ['53'] },
      { title: 'Security', precodes: ['46'] },
      { title: 'Shipping/Distribution', precodes: ['47'] },
      { title: 'Telecommunications', precodes: ['48'] },
      { title: 'Transportation', precodes: ['49'] },
      { title: 'Other', precodes: ['50'] },
      { title: "I don't work", precodes: ['51'] }
    ]
  },
  State: {
    name: 'State',
    lucidKey: 'STATE',
    button_text: 'State',
    type: 'checklist',
    options: [
      { title: 'Not Applicable', precodes: ['0', '52'] },
      { title: 'Alabama', abbrev: 'AL', precodes: ['1'] },
      { title: 'Alaska', abbrev: 'AK', precodes: ['2'] },
      { title: 'Arizona', abbrev: 'AZ', precodes: ['3'] },
      { title: 'Arkansas', abbrev: 'AR', precodes: ['4'] },
      { title: 'California', abbrev: 'CA', precodes: ['5'] },
      { title: 'Colorado', abbrev: 'CO', precodes: ['6'] },
      { title: 'Connecticut', abbrev: 'CT', precodes: ['7'] },
      { title: 'Delaware', abbrev: 'DE', precodes: ['8'] },
      { title: 'District of Columbia (D.C.)', abbrev: 'DC', precodes: ['9'] },
      { title: 'Florida', abbrev: 'FL', precodes: ['10'] },
      { title: 'Georgia', abbrev: 'GA', precodes: ['11'] },
      { title: 'Hawaii', abbrev: 'HI', precodes: ['12'] },
      { title: 'Idaho', abbrev: 'ID', precodes: ['13'] },
      { title: 'Illinois', abbrev: 'IL', precodes: ['14'] },
      { title: 'Indiana', abbrev: 'IN', precodes: ['15'] },
      { title: 'Iowa', abbrev: 'IA', precodes: ['16'] },
      { title: 'Kansas', abbrev: 'KS', precodes: ['17'] },
      { title: 'Kentucky', abbrev: 'KY', precodes: ['18'] },
      { title: 'Louisiana', abbrev: 'LA', precodes: ['19'] },
      { title: 'Maine', abbrev: 'ME', precodes: ['20'] },
      { title: 'Maryland', abbrev: 'MD', precodes: ['21'] },
      { title: 'Massachusetts', abbrev: 'MA', precodes: ['22'] },
      { title: 'Michigan', abbrev: 'MI', precodes: ['23'] },
      { title: 'Minnesota', abbrev: 'MN', precodes: ['24'] },
      { title: 'Mississippi', abbrev: 'MS', precodes: ['25'] },
      { title: 'Missouri', abbrev: 'MO', precodes: ['26'] },
      { title: 'Montana', abbrev: 'MT', precodes: ['27'] },
      { title: 'Nebraska', abbrev: 'NE', precodes: ['28'] },
      { title: 'Nevada', abbrev: 'NV', precodes: ['29'] },
      { title: 'New Hampshire', abbrev: 'NH', precodes: ['30'] },
      { title: 'New Jersey', abbrev: 'NJ', precodes: ['31'] },
      { title: 'New Mexico', abbrev: 'NM', precodes: ['32'] },
      { title: 'New York', abbrev: 'NY', precodes: ['33'] },
      { title: 'North Carolina', abbrev: 'NC', precodes: ['34'] },
      { title: 'North Dakota', abbrev: 'ND', precodes: ['35'] },
      { title: 'Ohio', abbrev: 'OH', precodes: ['36'] },
      { title: 'Oklahoma', abbrev: 'OK', precodes: ['37'] },
      { title: 'Oregon', abbrev: 'OR', precodes: ['38'] },
      { title: 'Pennsylvania', abbrev: 'PA', precodes: ['39'] },
      { title: 'Rhode Island', abbrev: 'RI', precodes: ['40'] },
      { title: 'South Carolina', abbrev: 'SC', precodes: ['41'] },
      { title: 'South Dakota', abbrev: 'SD', precodes: ['42'] },
      { title: 'Tennessee', abbrev: 'TN', precodes: ['43'] },
      { title: 'Texas', abbrev: 'TX', precodes: ['44'] },
      { title: 'Utah', abbrev: 'UT', precodes: ['45'] },
      { title: 'Vermont', abbrev: 'VT', precodes: ['46'] },
      { title: 'Virginia', abbrev: 'VA', precodes: ['47'] },
      { title: 'Washington', abbrev: 'WA', precodes: ['48'] },
      { title: 'West Virginia', abbrev: 'WV', precodes: ['49'] },
      { title: 'Wisconsin', abbrev: 'WI', precodes: ['50'] },
      { title: 'Wyoming', abbrev: 'WY', precodes: ['51'] },
      { title: 'American Samoa', abbrev: 'AS', precodes: ['53'] },
      { title: 'Federated States of Micronesia', abbrev: 'FSM', precodes: ['54'] },
      { title: 'Guam', abbrev: 'GU', precodes: ['55'] },
      { title: 'Marshall Islands', abbrev: 'MH', precodes: ['56'] },
      { title: 'Northern Mariana Islands', abbrev: 'MP', precodes: ['57'] },
      { title: 'Palau', abbrev: 'PW', precodes: ['58'] },
      { title: 'Puerto Rico', abbrev: 'PR', precodes: ['59'] },
      { title: 'Virgin Islands', abbrev: 'VI', precodes: ['60'] }
    ]
  },
  Device: {
    name: 'Device',
    description: 'What type of device are you using?',
    lucidKey: 'MS_is_mobile',
    button_text: 'Device',
    type: 'checkbox',
    options: [
      { title: 'Mobile or Tablet', precodes: ['true'] },
      { title: 'Desktop or Laptop', precodes: ['false'] }
    ]
  },
  'Job Title': {
    name: 'Job Title',
    description: 'What is your job title, level or responsibility?',
    lucidKey: 'STANDARD_JOB_TITLE',
    button_text: 'Job Title',
    type: 'checkbox',
    options: [
      { title: 'C-Level, Owner, Partner, President', precodes: ['1'] },
      { title: 'Vice President', precodes: ['2'] },
      { title: 'Director', precodes: ['3'] },
      { title: 'Manager', precodes: ['4'] },
      { title: 'Analyst', precodes: ['5'] },
      { title: 'Assistant or Associate', precodes: ['6'] },
      { title: 'Administrative', precodes: ['7'] },
      { title: 'Consultant', precodes: ['8'] },
      { title: 'Other', precodes: ['9', '10', '11'] }
    ]
  },
  'Parental Status': {
    name: 'Parental Status',
    description: 'Please choose the options that best describe your household:',
    lucidKey: 'Parental_Status_Standard',
    button_text: 'Parental Status',
    type: 'checkbox',
    options: [
      { title: 'Pregnant/expecting a child within the next 9 months', precodes: ['1'] },
      { title: 'One or more children under the age of 18 living in household', precodes: ['2'] },
      { title: 'One or more children aged 18 or older living in household', precodes: ['3'] },
      { title: 'No children living in household and not pregnant/expecting a child within the next 9 months', precodes: ['4'] }
    ]
  },
  'Relationship Status': {
    name: 'Relationship Status',
    description: 'What is your relationship status?',
    lucidKey: 'STANDARD_RELATIONSHIP',
    button_text: 'Relationship Status',
    type: 'checkbox',
    options: [
      { title: 'Single, never married', precodes: ['1'] },
      { title: 'Married', precodes: ['2'] },
      { title: 'Separated, divorced, or widowed', precodes: ['3'] },
      { title: 'Domestic partnership/living with someone', precodes: ['4'] },
      { title: 'Prefer not to answer', precodes: ['5'] }
    ]
  },
  'Household Type': {
    name: 'Household Type',
    description: 'What best describes your current household?',
    lucidKey: 'STANDARD_HOUSEHOLD_TYPE',
    button_text: 'Household Type',
    type: 'checkbox',
    options: [
      { title: 'Rented apartment', precodes: ['1'] },
      { title: 'Owned apartment', precodes: ['2'] },
      { title: 'Rented house', precodes: ['3'] },
      { title: 'Owned house', precodes: ['4'] },
      { title: 'Farm', precodes: ['5'] },
      { title: 'University Residence', precodes: ['6'] },
      { title: 'Living with parents', precodes: ['7'] },
      { title: 'Other', precodes: ['8'] }
    ]
  },
  'Company Dept.': {
    name: 'Company Dept.',
    description: 'Which department do you primarily work within at your organization?',
    lucidKey: 'STANDARD_COMPANY_DEPARTMENT',
    button_text: 'Company Dept.',
    type: 'checklist',
    options: [
      { title: 'Administration/General Staff', precodes: ['1'] },
      { title: 'Customer Service/Client Service', precodes: ['2'] },
      { title: 'Executive Leadership', precodes: ['3'] },
      { title: 'Finance/Accounting', precodes: ['4'] },
      { title: 'Human Resources', precodes: ['5'] },
      { title: 'Legal/Law', precodes: ['6'] },
      { title: 'Marketing', precodes: ['7'] },
      { title: 'Operations', precodes: ['8'] },
      { title: 'Procurement', precodes: ['9'] },
      { title: 'Sales/Business Development', precodes: ['10'] },
      { title: 'Technology Development Hardware (not only IT)', precodes: ['11'] },
      { title: 'Technology Development Software (not only IT)', precodes: ['12'] },
      { title: 'Technology Implementation', precodes: ['13'] },
      { title: 'Other', precodes: ['14'] },
      { title: "I don't work", precodes: ['15'] }
    ]
  },
  'B2B Decisions': {
    name: 'B2B Decisions',
    description: 'Please choose which departments/products you have influence or decision making authority over regarding spending/purchasing.',
    lucidKey: 'STANDARD_B2B_DECISION_MAKER',
    button_text: 'B2B Decisions',
    type: 'checklist',
    options: [
      { title: 'IT Hardware', precodes: ['1'] },
      { title: 'IT Software', precodes: ['2'] },
      { title: 'Printers and copiers', precodes: ['3'] },
      { title: 'Financial Department', precodes: ['4'] },
      { title: 'Human Resources', precodes: ['5'] },
      { title: 'Office supplies', precodes: ['6'] },
      { title: 'Corporate travel', precodes: ['7'] },
      { title: 'Telecommunications', precodes: ['8'] },
      { title: 'Sales', precodes: ['9'] },
      { title: 'Shipping', precodes: ['10'] },
      { title: 'Operations', precodes: ['11'] },
      { title: 'Legal services', precodes: ['12'] },
      { title: 'Marketing / Advertising', precodes: ['13'] },
      { title: 'Security', precodes: ['14'] },
      { title: 'Food services', precodes: ['15'] },
      { title: 'Auto leasing / purchasing', precodes: ['16'] },
      { title: 'Procurement', precodes: ['19'] },
      { title: 'Other', precodes: ['17'] },
      { title: "I don't have influence or decision making authority", precodes: ['18'] }
    ]
  },
  '# of Employees': {
    name: '# of Employees',
    description: 'Approximately how many employees work at your organization (all locations)?',
    lucidKey: 'STANDARD_NO_OF_EMPLOYEES',
    button_text: '# of Employees',
    type: 'checkbox',
    options: [
      { title: '1', precodes: ['1'] },
      { title: '2-10', precodes: ['2'] },
      { title: '11-50', precodes: ['3'] },
      { title: '51-100', precodes: ['4'] },
      { title: '101-500', precodes: ['5'] },
      { title: '501-1000', precodes: ['6'] },
      { title: '1001-5000', precodes: ['7'] },
      { title: 'Greater than 5000', precodes: ['8'] },
      { title: "I don't work/I don't know", precodes: ['9'] }
    ]
  },
  'Big Purchases': {
    name: 'Big Purchases',
    description: 'Which of the following products have you purchased in the last 2 years, or intend to buy in the next 12 months?',
    lucidKey: 'Big_Ticket_Purchases',
    button_text: 'Big Purchases',
    type: 'checkbox',
    options: [
      { title: 'Household Appliances', precodes: ['1'] },
      { title: 'TV', precodes: ['2'] },
      { title: 'Mobile phone', precodes: ['3'] },
      { title: 'Laptop', precodes: ['4'] },
      { title: 'Car', precodes: ['5'] },
      { title: 'Flight ticket', precodes: ['6'] },
      { title: 'House', precodes: ['7'] },
      { title: 'None of the above', precodes: ['-3105'] }
    ]
  }
}
